import React from 'react';
import MarketingShell from '../../components/MarketingShell';

export default function LegalPage({ title, updated, sections }) {
  return (
    <MarketingShell title={title} description={updated ? `Last updated ${updated}` : undefined}>
      <div className="space-y-6 rounded-xl border border-gray-100 bg-white p-6">
        {sections.map((section) => (
          <section key={section.heading} className="space-y-2">
            <h2 className="text-base font-semibold text-gray-900">{section.heading}</h2>
            {section.paragraphs.map((paragraph, index) => (
              <p key={`${section.heading}-${index}`} className="text-sm text-gray-600">
                {paragraph}
              </p>
            ))}
          </section>
        ))}
      </div>
    </MarketingShell>
  );
}
